import OrderCargoOrderDetailsRequest from "../../../../api/raily/order/cargo-order/details/order-cargo-order-details.request";
import OrderCargoOrderDetailsParams from "./order-cargo-order-details-params";

const create = (
  params: OrderCargoOrderDetailsParams,
): OrderCargoOrderDetailsRequest => {
  return {
    orderUuid: params.orderUuid,
  };
};

const orderCargoOrderDetailsParamsFactory = {
  create,
};

export default orderCargoOrderDetailsParamsFactory;
